export class UpdateSourceAccountAttributesInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aws",
            "baseName": "aws",
            "type": "UpdateAwsSourceAccountAttributes",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "UpdateGcpSourceAccountAttributes",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateSourceAccountAttributesInput.attributeTypeMap;
    }
    constructor() {
    }
}
